import i18nLocale from "@/helpers/locale";
export const discountSettingFormItems = [
  {
    formLabel: i18nLocale("discountRules.simultaneousPurchase"),
    prop: "purchaseSetting",
    options: [
      {
        label: i18nLocale("movie.nationwideUniversalTicket"),
        value: true
      },
      {
        label: i18nLocale("global.impossible"),
        value: false
      },
    ]
  },
  {
    formLabel: i18nLocale("discountRules.applicableNumber"),
    prop: "purchaseQty",
  },
  {
    formLabel: i18nLocale("discountRules.applicableDay"),
    prop: "useOnTheDay",
    options: [
      {
        label: i18nLocale("global.yes"),
        value: true
      },
      {
        label: i18nLocale("global.no"),
        value: false
      },
    ],
    disable: true
  },
  {
    formLabel: i18nLocale("discountRules.boxOffice"),
    prop: "boxOffice",
    options: [
      {
        label: i18nLocale("global.yes"),
        value: true
      },
      {
        label: i18nLocale("global.no"),
        value: false
      },
    ]
  },
  {
    formLabel: i18nLocale("discountRules.couponCombination"),
    prop: "couponCombinedUse",
    options: [
      {
        label: i18nLocale("global.yes"),
        value: true
      },
      {
        label: i18nLocale("global.no"),
        value: false
      },
    ],
    disable: true,
  },
  {
    formLabel: i18nLocale("discountRules.nationalCouponCombination"),
    prop: "movieTicketingCombinedUse",
    options: [
      {
        label: i18nLocale("global.yes"),
        value: true
      },
      {
        label: i18nLocale("global.no"),
        value: false
      },
    ],
    disable: true,
  },
];

export const discountSettingType = new Map([
  [0, "two"],
  [1, "three"],
  [2, "four"],
  [3, "five"],
  [4, "six"],
  [5, "seven"],
  [6, "eight"],
  [7, "nine"],
  [8, "ten"],
]);